<template>
  <div class="home">
    <!--banner-->
    <div class="banner">
      <div
        class="index_banner_title"
        style="display: flex; justify-content: center; flex-direction: column"
      >
        <h1 style="font-size: 3rem; color: inherit; margin-bottom: -0.1em">
          聚乙烯合成3D虚拟仿真实验软件
        </h1>
        <span style="font-size: 1rem; float: right; margin-top: 30px">
          钱建华 | 辽宁石油化工大学 | 上线时间：2022年
        </span>
        <div style="font-size: 1rem; float: right; margin-top: 10px">
          <span> 所属专业类：材料类 </span>
          <span style="margin-left: 20px"> 对应专业：高分子材料与工程 </span>
          <span style="margin-left: 20px"> 课程类型：专业课 </span>
          <span style="margin-left: 20px">实验类型：综合设计性 </span>
        </div>
        <div style="font-size: 1rem; float: right; margin-top: 10px">
          <span> 所属课程：高聚物合成工艺学、生产实习 </span>
        </div>
        <span style="font-size: 1rem; float: right; margin-top: 20px">
          《聚乙烯合成3D虚拟实验软件》是以企业真实场景为基础构建3D虚拟场景，具有DCS操作界面，能够实现操作功能的虚拟仿真软件。
        </span>
      </div>
      <div style="position: absolute; top: 370px; right: 35%">
        <!-- <el-button @click="opentopic">理论考核</el-button> -->
        <el-button @click="openwebgl" round>开始实验</el-button>
      </div>
    </div>
    <div class="content">
      <el-row :gutter="30" style="margin: 0px">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18" :offset="3">
          <div class="introduction">
            <el-row :gutter="10">
              <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" :offset="2">
                <div class="content_left_title">
                  <span>项目简介</span>
                </div>
                <div class="content_left_text">
                  聚乙烯合成3D虚拟实验软件是在教育数字化转型背景下，推出的聚乙烯生产工艺仿真实训平台，具备开展理论教学与实践教学双重功能，旨在提高学生的创新精神和工程实践能力，紧密围绕石油化工行业智能化、高端化和绿色化转型需求，以“减油增化、减油增材”为重点，将石油精神、抚油精神、安全与环保等思政元素有效融入课程内容之中，实现育人与育才的高度统一。聚乙烯合成3D虚拟实验软件系统主要由虚拟仿真系统、虚拟仿真云平台组成。虚拟仿真云平台是一个公用的可搭载虚拟仿真软件供用户使用，同时可对用户、资源、考核、分数等信息进行管理的系统。通过虚拟仿真云平台，用户可在线安装使用仿真软件，教师通过分析培训项目的使用情况，可有针对性的开展仿真教学活动。同时，可进行人员集中的局域网机房内仿真教学、测验，亦可进行人员分散的网络仿真考试，方便教师实时掌握仿真软件使用情况，进行科学高效的仿真教学及考核。
                </div>
              </el-col>
              <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
                <div class="content_right_01">
                  <!-- <img
                    src="../../assets/11.png"
                    style="
                      vertical-align: middle;
                      border-style: none;
                      width: 100%;
                    "
                  /> -->
                  <div
                    v-show="!videoState.video1"
                    class="cover_box"
                    @click="playVideo(1)"
                  >
                    <img class="cover_img" src="../../assets/cover/1.jpg" />
                    <img class="play_icon" src="../../assets/icons/play.png" />
                  </div>
                  <video
                    v-show="videoState.video1"
                    src="../../assets/video/introduce.mp4"
                    controls="controls"
                    style="
                      vertical-align: middle;
                      border-style: none;
                      width: 100%;
                      border-radius: 10px;
                    "
                  ></video>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="padding-top: 0px">
              <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" :offset="2">
                <div class="content_left_02">
                  <!-- <img
                    src="../../assets/img.png"
                    style="
                      vertical-align: middle;
                      border-style: none;
                      width: 100%;
                      margin-top: 20px;
                    "
                  /> -->
                  <div
                    v-show="!videoState.video2"
                    class="cover_box"
                    @click="playVideo(2)"
                  >
                    <img class="cover_img" src="../../assets/cover/2.jpg" />
                    <img class="play_icon" src="../../assets/icons/play.png" />
                  </div>
                  <video
                    v-show="videoState.video2"
                    src="../../assets/video/guide.mp4"
                    controls="controls"
                    style="
                      vertical-align: middle;
                      border-style: none;
                      width: 100%;
                      border-radius: 10px;
                    "
                  ></video>
                </div>
              </el-col>
              <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
                <div class="content_right_title_02">教学引导视频</div>
                <div class="content_left_text content_left_text_01">
                  《聚乙烯合成3D虚拟实验软件》是以企业真实场景为基础构建3D虚拟场景，具有DCS操作界面，能够实现操作功能的虚拟仿真软件，共分为系统认知、安全知识、场景漫游、生产操作、设备拆解、课程思政和结果与讨论等七个模块。
                  系统认知模块包含工艺认知、仪表认知和设备认知，通过动画的形式，展示工艺中常用仪表的控制原理、设备构造及控制原理。
                  安全知识模块包括常用原料如乙烯、1-丁烯、己烷、四氯化钛、三乙基铝和氢气的物理性质、化学性质、毒理学数据、消防措施、泄露应急处理和操作注意事项的相关知识。
                  场景漫游模块以3D的形式呈现聚乙烯的生产工艺，可实现在厂区内任意漫游，通过搜索设备位号可快速到达指定位置，并在设备上标注设备名称，便于学习者快速掌握相关生产工艺。
                  生产操作模块以2D的形式呈现聚乙烯工艺的聚合系统、分离系统、脱己烷系统、粉料输送系统、精制系统、蜡回收系统、造粒均化系统及己烷中转系统的DCS图和现场图，能够实现上述系统的开停车操作。
                  设备拆解模块通过以动画的形式展示了常见的泵、塔、反应器和储罐的基本结构和内部构造，可以实现设备的拆解与组装，并对设备原理及各部分的作用进行说明。
                  课程思政模块将石油精神和抚油精神有效融入到虚拟仿真软件，激发学生爱岗敬业、扎根基层及从事石油化工行业的自豪感。
                  结果与讨论模块将企业的真实生产数据为基础，通过建立相关模型，能够呈现工艺参数的变化对聚乙烯产品熔融指数及密度的影响。
                </div>
              </el-col>
            </el-row>
            <div style="padding: 50px 0px">
              <div class="module_row">
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/team', '1')"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >团队介绍</span
                      >
                      <img src="../../assets/icons/07.png" />
                    </div>
                  </el-button>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/introduction', '1')"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >实验目的</span
                      >
                      <img src="../../assets/icons/01.png" />
                    </div>
                  </el-button>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/introduction', 2)"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >实验原理</span
                      >
                      <img src="../../assets/icons/02.png" />
                    </div>
                  </el-button>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/introduction', 5)"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >实验教学过程</span
                      >
                      <img src="../../assets/icons/06.png" />
                    </div>
                  </el-button>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/introduction', '4')"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >实验方法</span
                      >
                      <img src="../../assets/icons/08.png" />
                    </div>
                  </el-button>
                </div>
              </div>
              <div class="module_row">
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/introduction', '5')"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >实验特色</span
                      >
                      <img src="../../assets/icons/04.png" />
                    </div>
                  </el-button>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/resource', '1')"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >教学资源</span
                      >
                      <img src="../../assets/icons/03.png" />
                    </div>
                  </el-button>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/resource', '2')"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >课程评价</span
                      >
                      <img src="../../assets/icons/10.png" />
                    </div>
                  </el-button>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/resource', '3')"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >等保与软著</span
                      >
                      <img src="../../assets/icons/09.png" />
                    </div>
                  </el-button>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <el-button
                    style="width: 230px; height: 230px"
                    @click="toRedirect('/hardware', 3)"
                  >
                    <div
                      style="
                        padding: 0px 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                      "
                    >
                      <span
                        style="
                          font-size: 18px;
                          font-weight: bold;
                          padding-bottom: 10px;
                        "
                        >技术架构</span
                      >
                      <img src="../../assets/icons/05.png" />
                    </div>
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data () {
    return {
      examData: {},
      examId: "",
      paperIds: [],
      JSESSIONID: localStorage.getItem("JSESSIONID"),
      videoState: {
        video1: false,
        video2: false,
      },
      ilabParam: {

      }
    };
  },
  methods: {
    openwebgl () {
      // this.$redirectTlszxSoftware();
      let userform = localStorage.getItem('userform');
      if (userform) {
        let obj = JSON.parse(userform);
        if (obj.userType === "Student" || obj.userType === "DeclareProfs") {
          this.$RedirectTlszxSoftware(this.ilabParam);
        } else if (obj.userType === "Teacher") {
          this.$RedirectTlszxPlace("/teacher/page/index");
        } else if (obj.userType === "Administrator") {
          this.$RedirectTlszxPlace("/management/user/institutions");
        } else {
          this.$message.error(`未知的用户类型【${obj.userType}】！`);
        }
      } else {
        this.$root.$emit('onLoginShow', true);
      }
      return;
      if (this.JSESSIONID) {
        var item = localStorage.getItem("JSESSIONID");
        let nextLocationTo =
          location.protocol + "//" + location.host + "/njgd/GL?";
        // window.open('https://tlszx.com/hysf/webgl/' + this.JSESSIONID)
        /* this.$axios.get("/facade/sessionId").then(resp => {
                        console.log('<script> location.replace(' + nextLocationTo + resp.data.result + ')<\/script>');
                        window.open('javascript:window.name;', '<script> location.replace(\'' + nextLocationTo + resp.data.result + "&A=A" + '\')<\/script>');
                    }); */
      } else {
        this.$router.push("/login");
      }
      //window.open('https://fqubwk.axshare.com/#id=xjtw91&p=%E9%A6%96%E9%A1%B5?sessionid=' + this.JSESSIONID)
    },
    toRedirect (value, num) {
      localStorage.setItem("redirectNum", num);
      this.$emit("toRedirect", value, num);
      window.scrollTo(0, 0);
    },
    opentopic () {

      return;
      if (this.JSESSIONID) {
        let userCode = localStorage.getItem("username");
        console.log(userCode);
        let url = "/exam/list";
        this.$axios.get(url).then((resp) => {
          console.log(resp);
          if (resp.data.success) {
            let isExam = false;
            for (let i = 0; i < resp.data.result.length; i++) {
              let date = this.dayjs().valueOf();
              if (resp.data.result[i].end > date) {
                this.examData[i] = resp.data.result[i];
                let stus = JSON.parse(this.examData[i].stuIds);
                console.log(stus);
                let examId = stus.find((data) => {
                  return data === userCode;
                });
                if (typeof examId !== "undefined") {
                  isExam = true;
                }
                this.examId = this.examData[i].examId;
                this.paperIds = JSON.parse(this.examData[i].paperIds)[0];
                console.log(this.paperIds);
              }
            }
            if (isExam) {
              this.$router.push("/theorytest");
            } else {
              alert("暂无考试");
            }
          }
        });
        // if (typeof this.paperIds === "undefined"){
        //     alert('暂无考试')
        // } else{
        //     this.$router.push('/theorytest')
        // }
      } else {
        this.$router.push("/login");
      }
    },
    // clearLocalStorage() {
    //     this.localStorage.clear();
    // }
    onLogin (userInfo) {
      this.$RedirectTlszxSoftware(this.ilabParam);
      return;
      let url = "/facade/detection";
      let params = {
        userId: userInfo.un,
        userName: userInfo.dis,
      };
      this.$axios.post(url, params).then((resp) => {
        if (resp.data.code === 200) {
          console.log(resp);
          let cookie = document.cookie;
          let JSESSIONID = cookie.split("JSESSIONID=")[1];

          localStorage.setItem("JSESSIONID", JSESSIONID);
          console.log("SESSION ID => " + JSESSIONID);
          localStorage.setItem("username", resp.data.result.userName);
          console.log("用户" + resp.data.result.userName);
          this.$message.success("登陆成功！");
          if (resp.data.result.userName !== "root") {
            this.$router.push({ path: "/" }).catch(() => { }); // eslint-disable-line
            window.location.reload();
          } else {
            this.$router.push({ path: "/class" }).catch((e) => {
              console.log(e);
            }); // eslint-disable-line
          }
        } else {
          this.$message.error("登陆失败！");
        }
      });
    },
    playVideo (num) {
      this.videoState['video' + num] = true;
      document.querySelectorAll('video')[num - 1].play();
    },
    loginGetInto (userform, token) {

      this.setItems(userform, token)

      if (this.isVerification === 0 && this.isRememberPassword) {
        this.setCookie("account", userform.userId, 7 * 24 * 60 * 60 * 1000)
        // base64加密密码
        let passWord = Base64.encode(this.form.getFieldValue('password'))
        this.setCookie("remember", passWord, 7 * 24 * 60 * 60 * 1000)
      } else {
        this.setCookie("account", "")
        this.setCookie("remember", "")
      }

      this.visible = false;

      if (userform.userType === "Student" || userform.userType === "DeclareProfs") {
        window.location.reload();
      } else if (userform.userType === "Teacher") {
        this.$RedirectTlszxPlace("/teacher/page/index");
      } else if (userform.userType === "Administrator") {
        this.$RedirectTlszxPlace("/management/user/institutions");
      } else {
        this.$message.error(`未知的用户类型【${userform.userType}】！`);
      }
    },
    setItems (userform, token) {
      localStorage.setItem('signature', userform.signature)
      localStorage.setItem('accessToken', token)
      localStorage.setItem('userform', JSON.stringify(userform))
      localStorage.setItem('userType', userform.userType)
      localStorage.setItem('declare', "TRUE")

      let params = userform.params;
      let keys = Object.keys(params);

      keys.forEach(key => {
        localStorage.setItem(key, params[key])
      })
    },
    setCookie (cName, value, expiredays) {
      var exdate = new Date()
      exdate.setTime(exdate.getTime() + expiredays)
      document.cookie = cName + '=' + decodeURIComponent(value) + ';path=/' +
        ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString());
    }
  },
  mounted () {
    let videos = document.querySelectorAll('video');
    videos.forEach((node, index) => {
      node.addEventListener('play', function () {
        pauseAll(index);
      })
    })

    function pauseAll (index) {
      videos.forEach((node, i) => {
        if (index !== i) { node.pause() }
      })
    };

    //ILab
    let splits = location.href.split("?")
    if (splits.length < 2)
      return;

    let url = splits[1];

    let param = url.split("&");

    this.ilabParam = {
      ticket: encodeURIComponent(param[0].split("=")[1]),
      token: encodeURIComponent(param[1].split("=")[1]),
    };

    console.log(this.ilabParam);

    let userform = localStorage.getItem("userform");
    let ticket = localStorage.getItem("ticket");

    if (userform && ticket === this.ilabParam.ticket)
      return

    let loginUrl = `https://jyxxnfz.lnpu.edu.cn/online/api/facade/ilab/login?ticket=${this.ilabParam.ticket}`;

    const that = this;

    this.$axios.post(loginUrl).then(resp => {
      if (resp.data.code === 200) {

        localStorage.setItem("ticket", this.ilabParam.ticket);

        let jwt = require('jsonwebtoken')
        let userform = JSON.parse(jwt.decode(resp.data.result.token).payload)

        that.loginGetInto(userform, resp.data.result.token)
      } else {
        this.$message.error(resp.data.message)
      }
    })

  },
};
</script>

<style scoped>
.home {
  height: 100%;
}

.banner {
  height: 700px;
  width: 100%;
  background: url('../../assets/banner/banner-1.png') repeat;
  background-size: 100% 700px;
  position: relative;
}

.content {
}

.introduction {
  background: url('../../assets/contentbg.png') no-repeat;
  background-size: 100% 100%;
  /*height: 1460px;*/
  margin-top: -250px;
  border-radius: 15px;
}

.index_banner_title {
  color: #ffffff;
  text-shadow: 0 0 4px #000000;
  float: left;
  width: 850px;
  margin-left: 20%;
  margin-top: 100px;
}

.content_left_title {
  color: #0e64d9;
  border-left: 10px solid #0e64d9;
  width: auto;
  font-size: 3rem;
  border-radius: 5px 0 0 0;
  margin-top: 5rem;
  padding-left: 10px;
}

.content_left_title_01 {
  font-size: 1rem;
  width: 100%;
  font-weight: 500;
  padding: 20px 0px;
}

.content_right_title_02 {
  color: #0e64d9;
  border-right: 10px solid #0e64d9;
  width: auto;
  text-align: right;
  font-size: 3rem;
  border-radius: 0 5px 0 0;
  padding-right: 10px;
  margin-top: 20px;
}

.content_left_text {
  font-size: 1.1rem;
  line-height: 1.8rem;
  width: 100%;
  padding: 0px 0px;
  text-indent: 2rem;
  text-align: justify;
}

.content_left_text_01 {
  line-height: 1.4;
  font-size: 1.1rem;
}

.content_right_01 {
  float: right;
  width: 95%;
  margin-top: 10rem;
}

.content_left_02 {
  float: left;
  width: 95%;
  margin-top: 6rem;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.cover_box {
  position: relative;
  cursor: pointer;
  border-radius: 10px;
}
.cover_img {
  vertical-align: middle;
  border-style: none;
  width: 100%;
  border-radius: 10px;
}
.play_icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  filter: opacity(0.8);
}
.module_row {
  margin: 30px 50px 0 50px;
  display: flex;
  justify-content: space-between;
}
</style>
